import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert } from "../../../../utils";

export const vehicleWareHouseListTodo = createAsyncThunk('vehicleWareHouseList', async ({ navigate }) => {

    try {
        const res = await axios({

            method: 'GET',
            url: process.env.REACT_APP_API_URL + `warehouse-vehicle`,
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const vehicleWareHouseListSlice = createSlice({
    name: 'vehicleWareHouseList',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(vehicleWareHouseListTodo.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data;
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.data = []
            }

        });
        builder.addCase(vehicleWareHouseListTodo.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default vehicleWareHouseListSlice.reducer; 